module.exports = __webpack_public_path__ + "img/Feature.40dab5e2.jpg";